import { defineComponent, computed } from "vue";
import { calculateAvailability } from "./component-library85.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "availability-information",
  props: {
    availability: {
      type: Object,
      require: true,
      default: () => {
      }
    },
    isPresale: {
      type: Boolean
    }
  },
  setup(__props, { expose }) {
    const props = __props;
    const availableState = computed(() => calculateAvailability(props.availability, props.isPresale));
    expose({ availableState });
    return { __sfc: true, props, availableState };
  }
});
export {
  _sfc_main as default
};
